import { render, staticRenderFns } from "./CustomerCardNumbers.vue?vue&type=template&id=3ad50037&scoped=true"
import script from "./CustomerCardNumbers.vue?vue&type=script&lang=ts"
export * from "./CustomerCardNumbers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad50037",
  null
  
)

export default component.exports